
import React from 'react';
import { WifiOff, CloudUpload, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { useDataSync } from '../hooks/useDataSync';

const OfflineIndicator = () => {
  const { isOnline, syncStatus, pendingChanges } = useDataSync();

  if (isOnline && syncStatus === 'Synced' && pendingChanges === 0) return null;

  const isOffline = !isOnline;
  const isSyncing = syncStatus === 'Syncing' || (isOnline && pendingChanges > 0);
  const isError = syncStatus === 'Error';

  const toneClass = isOffline
    ? 'bg-red-600 dark:bg-red-900 text-white dark:text-red-100'
    : isError
      ? 'bg-amber-600 dark:bg-amber-900 text-white dark:text-amber-100'
      : 'bg-teal-600 dark:bg-teal-900 text-white dark:text-teal-100';

  const icon = isOffline
    ? <WifiOff className="w-4 h-4" />
    : isError
      ? <AlertTriangle className="w-4 h-4" />
      : isSyncing
        ? <CloudUpload className="w-4 h-4 animate-pulse" />
        : <CheckCircle2 className="w-4 h-4" />;

  const message = isOffline
    ? `You are currently offline. ${pendingChanges > 0 ? `${pendingChanges} change${pendingChanges > 1 ? 's' : ''} waiting to sync.` : 'Changes will sync when connection is restored.'}`
    : isError
      ? 'Sync issue detected. Your changes are saved locally and will retry automatically.'
      : pendingChanges > 0
        ? `Saving ${pendingChanges} pending change${pendingChanges > 1 ? 's' : ''}...`
        : 'All changes synced.';

  return (
    <div className={`px-4 py-2 text-center text-sm font-bold flex items-center justify-center gap-2 animate-in slide-in-from-top sticky top-0 z-50 shadow-md ${toneClass}`}>
      {icon}
      {message}
    </div>
  );
};

export default OfflineIndicator;
